<template>
  <v-layout class="container-modal">
    <v-dialog :modelValue="dialog" @click:outside="close()" max-width="1100px" transition="dialog-bottom-transition">
      <v-card>
        <v-form>
          <v-card-title class="p-3 header-modal mb-4">
            <span class="headline text-white">Visitas del envío #{{ shipping_code }}</span>
          </v-card-title>

          <v-card-text>
            <Table :list="shipping_visits" :header="header" :loading="loading_visits">
              <template v-slot:rows="{ item }">
                <td class="table-cell">{{ item.shipping.creation_date }}</td>
                <td class="table-cell">{{ item.creation_date }}</td>
                <td class="table-cell">{{ item.shipping.destination_address }}</td>
                <td class="table-cell">{{ item.shipping.external_reference || "-" }}</td>
                <td class="table-cell">{{ item.state != null ? item.state.name : "-" }}</td>
                <td class="table-cell text-center">
                  <img @click="viewPhoto(item)" :src="require('@/assets/images/view.png')" class="mr-2 pointer icon-table" />
                </td>
              </template>
            </Table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <Button flat class="btn text-capitalize text-white me-1 btn-modal" type="button" rounded="xl" height="50" text @click="close()" label="Cerrar" color="error"></Button>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- 📸 Modal de Foto / Detalles -->
    <v-dialog v-model="photoDialog" max-width="600px">
      <v-card>
        <v-card-title class="p-3 header-modal mb-4">
          <span class="headline text-white">Detalles del Envío</span>
        </v-card-title>
        <v-card-text v-if="selectedVisit">
          <p v-if="selectedVisit.state.id === ShippingState.STATE_DELIVERED || selectedVisit.state.id === ShippingState.STATE_RETURNED"><strong>DNI:</strong> {{ selectedVisit.dni }}</p>
          <p v-if="selectedVisit.state.id === ShippingState.STATE_DELIVERED || selectedVisit.state.id === ShippingState.STATE_RETURNED"><strong>Aclaracion:</strong> {{ selectedVisit.aclaracion }}</p>
          <p v-if="selectedVisit.state.id === ShippingState.STATE_DELIVERED || selectedVisit.state.id === ShippingState.STATE_RETURNED"><strong>Vinculo:</strong> {{ selectedVisit.vinculo }}</p>
          <p v-if="selectedVisit.state.id === ShippingState.STATE_RETURNED || selectedVisit.state.id === ShippingState.STATE_NOT_DELIVERED"><strong>Motivo:</strong> {{ selectedVisit.reason }}</p>
          <div class="d-flex justify-center align-center flex-column">
            <v-img :width="300" :height="300" cover :src="selectedVisit.photo_url"></v-img>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <Button flat class="btn text-capitalize text-white me-1 btn-modal" type="button" rounded="xl" height="50" text @click="photoDialog = false" label="Cerrar" color="error"></Button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";
import Button from "@/components/Button.vue";
import Table from "@/components/Table.vue";
import { shippingService } from "@/libs/ws/Seller/shippingService";
import ShippingState from "@/constants/shipping_state";

export default {
  mixins: [ValidMixin],
  components: { Button, Table },
  props: {
    dialog: Boolean,
    closeModalVisit: Function,
    shipping_id: Number,
    shipping_code: String,
  },
  data() {
    return {
      shipping_visits: [],
      ShippingState: ShippingState,
      loading_visits: false,
      photoDialog: false,
      selectedVisit: null,
      header: [
        { name: "Fecha creación", value: "shipping.creation_date", align: "left" },
        { name: "Fecha visita", value: "creation_date", align: "left" },
        { name: "Dirección", value: "shipping.destination_address", align: "left" },
        { name: "Referencia", value: "shipping.external_reference", align: "left" },
        { name: "Estado", value: "state.name", align: "left" },
        { name: "Acción", align: "center" },
      ],
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.loadShippingVisit();
      }
    },
  },
  methods: {
    close() {
      this.$emit("closeModalVisit");
      this.shipping_visits = [];
    },
    viewPhoto(item) {
      this.selectedVisit = item;
      this.photoDialog = true;
    },
    loadShippingVisit() {
      this.loading_visits = true;
      const params = { id: this.shipping_id };
      shippingService
        .listShippingVisits(params)
        .then((response) => {
          if (response.status) {
            this.shipping_visits = response.result;
          }
        })
        .catch((e) => {
          console.error("Error cargando visitas", e);
        })
        .finally(() => {
          this.loading_visits = false;
        });
    },
  },
};
</script>
